import React from 'react'

const Home = ({
    homeRef,
    addRightSideRef,
    manzaRef,
}) => {
    return (<>
        <div className="bg-white text-black h-[130vw] relative overflow-hidden"
            ref={homeRef}
            id={`home`}
        >
            <div className="absolute">
                <div className=" flex opacity-100">
                    <img ref={addRightSideRef} className="h-[10vw] w-[10vw] mt-[12vw] ml-[8vw] mr-[8vw] object-cover" src="/js.png" alt="Card" />
                    <img ref={addRightSideRef} className="h-[11vw] w-[11vw] mt-[4vw] object-cover" src="/flutter.png" alt="Card" />
                    <img ref={addRightSideRef} className="h-[10vw] w-[10vw] mt-[18vw] ml-[7vw] object-cover" src="/react.jpg" alt="Card" />
                    <img ref={addRightSideRef} className="h-[12vw] w-[12vw] mt-[9vw] ml-[8vw] mr-[7vw] object-cover" src="/vue.png" alt="Card" />
                    <img ref={addRightSideRef} className="h-[11vw] w-[11vw] mt-[6vw] object-cover" src="/angular.svg" alt="Card" />
                </div>
                <div className=" flex opacity-100">
                    <img ref={addRightSideRef} className="h-[10vw] w-[10vw] mt-[12vw] ml-[8vw] mr-[8vw] object-cover" src="/tailwind.png" alt="Card" />
                    <img ref={addRightSideRef} className="h-[11vw] w-[11vw] mt-[4vw] object-cover" src="/bootstrap.svg" alt="Card" />
                    <img ref={addRightSideRef} className="h-[10vw] w-[10vw] mt-[18vw] ml-[7vw] object-cover" src="/next-js.png" alt="Card" />
                    <img ref={addRightSideRef} className="h-[12vw] w-[12vw] mt-[9vw] ml-[8vw] mr-[7vw] object-cover" src="/postman.webp" alt="Card" />
                    <img ref={addRightSideRef} className="h-[11vw] w-[11vw] mt-[6vw] object-cover" src="/nodejs.png" alt="Card" />
                </div>
                <div className=" flex opacity-100">
                    <img ref={addRightSideRef} className="h-[10vw] w-[10vw] mt-[12vw] ml-[8vw] mr-[8vw] object-cover" src="/graphql.png" alt="Card" />
                    <img ref={addRightSideRef} className="h-[11vw] w-[11vw] mt-[4vw] object-cover" src="/express.png" alt="Card" />
                    <img ref={addRightSideRef} className="h-[10vw] w-[10vw] mt-[18vw] ml-[7vw] object-cover" src="/mongodb.png" alt="Card" />
                    <img ref={addRightSideRef} className="h-[12vw] w-[12vw] mt-[9vw] ml-[8vw] mr-[7vw] object-cover" src="/postgresql.svg" alt="Card" />
                    <img ref={addRightSideRef} className="h-[11vw] w-[11vw] mt-[6vw] object-cover" src="/mysql.png" alt="Card" />
                </div>
                <div className=" flex opacity-100">
                    <img ref={addRightSideRef} className="h-[10vw] w-[10vw] mt-[12vw] ml-[8vw] mr-[8vw] object-cover" src="/gcp.png" alt="Card" />
                    <img ref={addRightSideRef} className="h-[11vw] w-[11vw] mt-[4vw] object-cover" src="/aws.png" alt="Card" />
                    <img ref={addRightSideRef} className="h-[10vw] w-[10vw] mt-[18vw] ml-[7vw] object-cover" src="/firebase.webp" alt="Card" />
                    <img ref={addRightSideRef} className="h-[12vw] w-[12vw] mt-[9vw] ml-[8vw] mr-[7vw] object-cover" src="/bigchaindb.webp" alt="Card" />
                    <img ref={addRightSideRef} className="h-[11vw] w-[11vw] mt-[6vw] object-cover" src="/matrix.png" alt="Card" />
                </div>
            </div>
            <div className="w-full h-[50vh] flex justify-center items-center">
                <div
                    ref={manzaRef}
                    className=" font-['Work_Sans'] font-bold text-[#2B292A] text-[15vw] opacity-100 drop-shadow"><label className='hover:text-[#E65445] '>MAN</label><label className='text-[#E65445]'>ZA</label></div>
            </div>
        </div>
    </>
    )
}

export default Home